import PageWrapper from "components/PageWrapper";
import SpaceliftLogo from "ds/components/SpaceliftLogo/Logo";

import styles from "./styles.module.css";

const SpaceliftLoader = () => (
  <PageWrapper className={styles.wrapper}>
    <SpaceliftLogo className={styles.logo} size="large" />
  </PageWrapper>
);

export default SpaceliftLoader;
